import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const usePostURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPost, setErroresPost] = useState(null);

  const postData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPost(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos),
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        const json = await response.json();
        setErroresPost(json.errors ?? json.errores ?? ["Error al actualizar los datos"]);
      } else {
        // Nuevo contrato: body { ok, data, errors }
        const env = await response.json().catch(() => null);
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            datosGrabados(response.headers.get('Location') ?? env.data ?? null);
          } else {
            setErroresPost(env.errors ?? env.errores ?? ["Error al actualizar los datos"]);
          }
        } else {
          datosGrabados(response.headers.get('Location'));
        }
      }
    } catch (err) {
      console.error("Error Post", err.message);
      setErroresPost(["Error al actualizar los datos"]);
    }
    setGrabando(false);
  }, []);

  const resetErroresPost = useCallback(() => {
    setErroresPost(null);
  },[]);

  return { isGrabando, erroresPost, postData, resetErroresPost };
};

export default usePostURL;
